// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   fetchSkipEmi,
//   updateSkipEmi,
// } from '../redux/slices/skipEmiSlice';
// import '../modalstyles/SkipEmiModal.css';

// const SkipEmiModal = ({ onClose }) => {
//   const dispatch = useDispatch();
//   const { days, loading, error } = useSelector((state) => state.skipEmi);

//   useEffect(() => {
//     dispatch(fetchSkipEmi());
//   }, [dispatch]);

//   const handleToggle = (id, day, currentStatus) => {
//     dispatch(updateSkipEmi({ id, day, status: !currentStatus }));
//   };

//   return (
//     <div className="SkipEmiModal-backdrop">
//       <div className="SkipEmiModal-modal">
//         <div className="SkipEmiModal-header">
//           <h3 className="SkipEmiModal-title">Skip EMI On</h3>
//           <button onClick={onClose} className="SkipEmiModal-closeBtn">
//             &times;
//           </button>
//         </div>

//         <div className="SkipEmiModal-body">
//           {loading && <p>Loading...</p>}
//           {error && <p className="error">{error}</p>}
//           {!loading &&
//             days.map(({ id, day, status }) => (
//               <div key={id} className="SkipEmiModal-dayRow">
//                 <label className="day-label">{day}</label>
//                 <label className="switch">
//                   <input
//                     type="checkbox"
//                     checked={status}
//                     onChange={() => handleToggle(id, day, status)}
//                   />
//                   <span className="slider round"></span>
//                 </label>
//               </div>
//             ))}
//         </div>

//         <div className="SkipEmiModal-footer">
//           <button onClick={onClose} className="SkipEmiModal-saveBtn">
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SkipEmiModal;




import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import '../modalstyles/SkipEmiModal.css';
import { EditIcon, TrashIcon } from 'lucide-react';

const API_BASE = 'https://payyug.in/api';

const DAYS_OF_WEEK = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

const SkipEmiModal = ({ onClose }) => {
  const [dayStatuses, setDayStatuses] = useState(
    DAYS_OF_WEEK.reduce((acc, day) => ({ ...acc, [day]: false }), {})
  );
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  
  const [toast, setToast] = useState(null);

  const superAdminId = useMemo(
    () => Number(localStorage.getItem('adminuserId')),
    []
  );

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => {
      setToast(null);
    }, 3500);
  };

  const fetchSchedules = useCallback(async () => {
    if (!superAdminId) {
      showToast('Super Admin ID not found in local storage.', 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE}/get-skip-emi`, {
        params: { superAdminId },
      });

      const data = response?.data || [];
      const dataArray = Array.isArray(data) ? data : data?.data || [];
      setSchedules(dataArray);

      const updatedStatuses = DAYS_OF_WEEK.reduce(
        (acc, day) => ({ ...acc, [day]: false }),
        {}
      );

      dataArray.forEach((item) => {
        if (item.day) {
          updatedStatuses[item.day] = Boolean(item.status);
        }
      });
      setDayStatuses(updatedStatuses);
    } catch (err) {
      showToast(
        err.response?.data?.message || err.message || 'Failed to fetch schedules.',
        'error'
      );
    } finally {
      setLoading(false);
    }
  }, [superAdminId]);

  useEffect(() => {
    fetchSchedules();
  }, [fetchSchedules]);


  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  // Local switch toggle
  const handleToggleChange = (day) => {
    setDayStatuses((prev) => ({ ...prev, [day]: !prev[day] }));
  };

  // 2. CREATE / SAVE: Submit selected days
  const handleSubmit = async () => {
    setActionLoading(true);

    const selectedDays = Object.entries(dayStatuses)
      .filter(([_, status]) => status)
      .map(([day, status]) => ({
        superAdminId: Number(superAdminId),
        day,
        status: Boolean(status),
      }));

    if (selectedDays.length === 0) {
      showToast('Please select at least one day before submitting.', 'error');
      setActionLoading(false);
      return;
    }

    try {
      // Send selected objects to endpoint
     const res= await Promise.all(
        selectedDays.map((payload) =>
          axios.post(`${API_BASE}/set-skip-emi`, payload)
        )
      );

      showToast(res?.data?.message||'Skip EMI schedule saved successfully!', 'success');
      await fetchSchedules();
    } catch (err) {
      showToast(
        err.response?.data?.message || err.message || 'Failed to save schedule.',
        'error'
      );
    } finally {
      setActionLoading(false);
    }
  };

  // 3. UPDATE: Inline status change in table
  const handleInlineUpdate = async (item) => {
    const payload = {
      superAdminId: Number(superAdminId),
      day: item.day,
      status: !item.status,
    };

    try {
     const res= await axios.put(`${API_BASE}/update-skip-emi/${item.id}`, payload);
      showToast(res?.data?.message||`Updated status for ${item.day}.`, 'success');
      await fetchSchedules();
    } catch (err) {
      showToast(
        err.response?.data?.message || err.message || 'Failed to update schedule.',
        'error'
      );
    }
  };

  // 4. DELETE: Remove single day schedule
  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this schedule record?')) return;

    try {
     const res= await axios.delete(`${API_BASE}/delete-skip-emi/${id}`, {
        params: { superAdminId },
      });
      showToast(res?.data?.message||'Schedule deleted successfully.', 'success');
      await fetchSchedules();
    } catch (err) {
      showToast(
        err.response?.data?.message || err.message || 'Failed to delete record.',
        'error'
      );
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="sem-backdrop"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
    >
      <div className="sem-modal">
        {/* Toast Alert Popup */}
        {toast && (
          <div className={`sem-toast sem-toast-${toast.type}`}>
            <span>{toast.message}</span>
            <button onClick={() => setToast(null)} className="sem-toast-close">&times;</button>
          </div>
        )}

        {/* Modal Header */}
        <div className="sem-header">
          <div className="sem-header-title">
            <h3>Skip EMI Settings</h3>
            <span className="sem-badge">Admin ID: {superAdminId || 'N/A'}</span>
          </div>
          <button onClick={onClose} className="sem-close-btn" aria-label="Close modal">
            &times;
          </button>
        </div>

        {/* Modal Body */}
        <div className="sem-body">
          {/* Section 1: Configure Days */}
          <div className="sem-section">
            <h4 className="sem-section-title">Select Days to Skip</h4>
            <div className="sem-days-grid">
              {DAYS_OF_WEEK.map((day) => {
                const isChecked = Boolean(dayStatuses[day]);
                return (
                  <div key={day} className={`sem-day-card ${isChecked ? 'active' : ''}`}>
                    <span className="sem-day-name">{day}</span>
                    <label className="sem-switch">
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => handleToggleChange(day)}
                        disabled={actionLoading}
                      />
                      <span className="sem-slider"></span>
                    </label>
                  </div>
                );
              })}
            </div>

            <div className="sem-action-row">
              <button
                type="button"
                className="sem-btn sem-btn-primary"
                onClick={handleSubmit}
                disabled={actionLoading}
              >
                {actionLoading ? 'Saving...' : 'Save Selected Days'}
              </button>
            </div>
          </div>

          <hr className="sem-divider" />

          {/* Section 2: Active Reports Table */}
          <div className="sem-section">
            <h4 className="sem-section-title">Active Schedule Report</h4>
            {loading ? (
              <p className="sem-placeholder-text">Loading schedules...</p>
            ) : !schedules || schedules.length === 0 ? (
              <p className="sem-placeholder-text">No active skip days configured yet.</p>
            ) : (
              <div className="sem-table-wrapper">
                <table className="sem-table">
                  <thead>
                    <tr>
                      <th>Day</th>
                      <th>Status</th>
                      <th className="sem-text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {schedules.map((item, index) => (
                      <tr key={item.id || item.day || index}>
                        <td className="sem-font-medium">{item.day}</td>
                        <td>
                          <span
                            className={`sem-status-pill ${
                              item.status ? 'pill-active' : 'pill-inactive'
                            }`}
                          >
                            {item.status ? 'True' : 'False'}
                          </span>
                        </td>
                        <td className="sem-text-right">
                          <button
                            className="sem-btn-icon sem-btn-edit"
                            onClick={() => handleInlineUpdate(item)}
                            disabled={actionLoading}
                          >
                            <EditIcon/>
                          </button>
                          <button
                            className="sem-btn-icon sem-btn-delete"
                            onClick={() => handleDelete(item.id)}
                            disabled={actionLoading}
                          >
                            <TrashIcon/>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* Modal Footer */}
        <div className="sem-footer">
          <button onClick={onClose} className="sem-btn sem-btn-secondary">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SkipEmiModal;